import React from 'react';

import './index.scss';

const Footer: React.FC = () => {
  const frameArr = [
    'React',
    'React Router',
    'Framer Motion',
    'Sass',
    'TypeScript'
  ];

  return (
        <footer id="main-footer" className="footer">
      <span>
        个人博客系统
        {/* <a href="#" target='_blank' rel='noreferrer' className="text">
          「源代码」
        </a> */}
      </span>
      <span>
        <a href="https://beian.mps.gov.cn" target='_blank' rel='noreferrer' className="text">
          鲁公网安备37098302000982号
        </a>
      </span>
      <div id="main-footer-tech-stack">
        <span className="tech-label">技术栈：</span>
        {frameArr.map((item, index) => (
          <span className="siteFrame" key={index}>
            {item}
          </span>
        ))}
      </div>
        </footer>
    );
};

export default Footer;
